import { NamedFeatureFlags } from '@kaiizen/kai-pro-api';
import { deleteCookieValue, getCookieValue, setCookieValue } from './cookieLib';

export const OPT_IN_COOKIE_KEY = 'newExperienceOptIn';

export const isOptedIntoNewExperience = (featureFlags: NamedFeatureFlags): boolean => !!getCookieValue(OPT_IN_COOKIE_KEY) && !!featureFlags.newScopeBuilderFlow;

export const optIntoNewExperience = (): void => setCookieValue(OPT_IN_COOKIE_KEY, '1');

export const optOutOfNewExperience = (): void => deleteCookieValue(OPT_IN_COOKIE_KEY);
